<template>
  <div>
    <b-row>
      <b-col v-for="(field, idx) in fields" :key="idx" md="2">
        <div class="input-container">
          <span>
            {{ field.previewLabel }}
          </span>
          <FormulateInput
            v-bind="field"
            v-model="value"
            type="date-picker"
            :range="range"
            :format="format"
            :datepickerType="datepickerType"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {},
    label: {},
    tooltip: {},
    format: {},
    range: {},
    datepickerType: {
      default: 'date',
    }
  },
  data() {
    return {
      value: null,
      fields: [
        {
          previewLabel: 'Basic (With focus)',
          label: this.label,
          value: this.value,
        },
        {
          previewLabel: 'With Placeholder',
          placeholder: this.placeholder,
          label: this.label,
          value: this.value,
        },
        {
          previewLabel: 'Disabled',
          placeholder: this.placeholder,
          label: this.label,
          value: this.value,
          disabled: true,
        },
        {
          previewLabel: 'With Tooltip',
          placeholder: this.placeholder,
          tooltip: this.tooltip,
          label: this.label,
          value: this.value,
        },
        {
          previewLabel: 'With Validation',
          placeholder: this.placeholder,
          label: this.label,
          value: this.value,
          validation: 'required',
          help: true,
        },
        {
          previewLabel: 'With Error',
          placeholder: this.placeholder,
          label: this.label,
          value: this.value,
          validation: 'required',
          validationBehavior: 'live',
          errorBehavior: 'live',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  min-height: 130px;
  border-radius: 4px;
  border: 1px solid rgba(slategray, 0.5);

  span {
    background: rgba(slategray, 0.3);
    color: rgba(black, 0.5);
    padding: 0 0.5rem;
    margin: -0.5rem -0.5rem 0 -0.5rem;
    font-size: 0.6rem;
  }
}
</style>
